import { Fragment } from 'react'

import { Box } from '@material-ui/core'
import { Theme, makeStyles } from '@material-ui/core/styles'

import SimpleCopyrightFooter from './SimpleCopyrightFooter'

type FooterTheme = 'white' | 'small'

type Props = {
  theme?: FooterTheme
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& a': {
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
      '&:hover, &:focus, &:hover:focus': {
        color: theme.palette.text.secondary,
        textDecoration: 'none',
      },
    },
  },
}))

const CopyrightFooter = ({ theme = 'white' }: Props) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <SimpleCopyrightFooter theme={theme}>
        <Fragment>
          <a
            href="https://www.scoir.com/scoir-student-terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          &nbsp;|&nbsp;
          <a
            href="http://www.scoir.com/accessibility"
            target="_blank"
            rel="noopener noreferrer"
          >
            Accessibility
          </a>
        </Fragment>
      </SimpleCopyrightFooter>
    </Box>
  )
}

export default CopyrightFooter
